import { render, staticRenderFns } from "./customBoxWord.vue?vue&type=template&id=7f378115&scoped=true&"
import script from "./customBoxWord.vue?vue&type=script&lang=js&"
export * from "./customBoxWord.vue?vue&type=script&lang=js&"
import style0 from "./customBoxWord.vue?vue&type=style&index=0&id=7f378115&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f378115",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f378115')) {
      api.createRecord('7f378115', component.options)
    } else {
      api.reload('7f378115', component.options)
    }
    module.hot.accept("./customBoxWord.vue?vue&type=template&id=7f378115&scoped=true&", function () {
      api.rerender('7f378115', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/customBoxWord.vue"
export default component.exports